import { GymMembership, MembershipChannel } from '../../core/services/membership.service';
import { formatLongDate } from '@core/utils';

/// "Üyeliğim" metinleri ve uyarı bandı kuralı (spec C, "Üyeliğim"). Saf fonksiyonlar.
export const MEMBERSHIP_ROUTE = '/settings/uyelik';
/** Kabuk bandının kapatma kaydı (sessionStorage); giriş ve çıkışta AuthService temizler. */
export const MEMBERSHIP_BANNER_KEY = 'mypt-membership-banner';
/** Bitişe bu kadar gün (veya daha az) kalınca kabukta uyarı bandı çıkar. */
export const BANNER_DAYS = 7;

export const CHANNEL_LABELS: Readonly<Record<MembershipChannel, string>> = {
  trial: 'Deneme',
  apple_iap: 'App Store',
  google_iap: 'Google Play',
  iban: 'Havale / EFT',
  cash: 'Nakit',
};

export const isStoreChannel = (c: MembershipChannel): boolean => c === 'apple_iap' || c === 'google_iap';

export const formatTrDate = (iso: string): string => formatLongDate(iso);

export function statusHeadline(m: GymMembership): string {
  switch (m.status) {
    case 'trial':
      return m.daysLeft && m.daysLeft > 0 ? `Deneme sürümü · ${m.daysLeft} gün kaldı` : 'Deneme sürümü · bugün bitiyor';
    case 'active':
      return m.endsAt ? `Aktif · ${formatTrDate(m.endsAt)} tarihine kadar` : 'Aktif';
    case 'expired':
      return m.endsAt ? `Süresi doldu · ${formatTrDate(m.endsAt)}` : 'Süresi doldu';
  }
}

export function bannerText(m: GymMembership): string | null {
  if (m.status === 'expired') return 'Üyeliğinizin süresi doldu; yeni kayıt ekleyemezsiniz.';
  if (m.daysLeft === null || m.daysLeft > BANNER_DAYS) return null;
  if (m.status === 'trial') {
    return m.daysLeft > 0 ? `Deneme sürenizin bitmesine ${m.daysLeft} gün kaldı.` : 'Deneme süreniz bugün bitiyor.';
  }
  return m.daysLeft > 0 ? `Aboneliğinizin bitmesine ${m.daysLeft} gün kaldı.` : 'Aboneliğiniz bugün bitiyor.';
}
